import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GiftCardStepService } from '../../giftcard/services/giftcard-step.service';
import { BookingStepService } from '../../booking/services/booking-step.service';
import { OrderStateService } from '../../order/services/order-state.service';
import { OrderTypeEnum } from '../../order/models/order-type.enum';
import { Order } from '../../order/models/order';
import { BookingStepEnum } from '../../booking/models/booking-step.enum';
import { map } from 'rxjs/operators';
import { BookingProductStepService } from '../../booking/services/booking-product-step.service';

@Injectable()
export class PaymentStartGuard implements CanActivate {

  constructor(
    private router: Router,
    private giftCardStepService: GiftCardStepService,
    private bookingStepService: BookingStepService,
    private orderStateService: OrderStateService,
    private bookingProductStepService: BookingProductStepService,
  ) { }

  private get _order(): Order {
    return this.orderStateService.order;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.orderStateService.isNeedReloadOrder) {
      return this.bookingStepService.initFromLoadOrder(BookingStepEnum.Payment)
        .pipe(
          map(_ => {
            return this.isCanActivate();
          }));
    }

    return this.isCanActivate();
  }

  isCanActivate(): boolean {
    if (this._order) {
      if (this._order.isNew) {
        // Order isNew
        if (this._order.orderType === OrderTypeEnum.Giftcard) {
          // Gift
          if (this.giftCardStepService.isPaymentPageAvailable) {
            return true;
          }

          this.router.navigateByUrl('/giftcard');
          return false;
        } else {
          // Booking
          if (this.bookingStepService.isBookingPaymentAvailable) {
            return true;
          }
          if (this.bookingProductStepService.isPaymentPageAvailable) {
            return true;
          }

          this.router.navigate(['/booking/register']);
          return false;
        }

      } else {
        // Order !isNew, exist and loaded
        return !this._order.isPaid;
      }
    } else {
      // no order - may be payment back
      if (!this.orderStateService.sessionOrderId) {
        this.router.navigate(['partner/orders']);
        return false;
      } else {
        return true;
      }
    }
  }
}
